import React, { useState, useEffect, useCallback } from 'react'
import { Paper } from '@material-ui/core'
import { useStyles } from './navigation-bar.styles'
import { useHistory, useLocation } from 'react-router-dom'
import NavigationTabs from './tabs/navigation-tabs'
import NavigationTab from './tabs/tab/navigation-tab'
import { useUserContext } from 'app/shared/state/user-context'
import SearchUser from '../search-user/search-user'

type NavItemType = {
  label: string
  path: string
}

const NavigationBar = () => {
  const history = useHistory()
  const classes = useStyles()
  const { pathname } = useLocation()
  const { currentUser } = useUserContext()
  const [navItems, setNavItems] = useState<NavItemType[]>([])

  useEffect(() => {
    if (!currentUser) {
      return
    }

    let navItems: NavItemType[] = []

    if (currentUser.isGlobalAdmin) {
      navItems = [
        { label: 'Communities', path: '/communities' },
        { label: 'Global admins', path: '/users' },
        { label: 'Diensten', path: '/services' },
      ]
    } else {
      navItems = []
    }

    setNavItems(navItems)
  }, [currentUser])

  /**
   * Returns the selected (prefix) path
   */
  const getCurrentPrefixPath = useCallback(() => {
    const matchingPaths = navItems.filter((x) => pathname.startsWith(x.path))

    if (matchingPaths.length > 0) {
      return matchingPaths[0].path
    }

    if (navItems.length === 0) {
      return ''
    }

    return navItems[0].path
  }, [pathname, navItems])

  const [selected, setSelected] = useState<string | undefined>(undefined)

  useEffect(() => {
    setSelected(getCurrentPrefixPath())
  }, [pathname, getCurrentPrefixPath])

  /**
   * @param {React.ChangeEvent<{}>} _event
   * @param {number} selected
   */
  const handleChange = (_event: React.ChangeEvent<{}>, selected: any) => {
    setSelected(selected)
  }

  /**
   * @param {(React.MouseEvent | React.KeyboardEvent)} e
   * @param {string} url
   */
  const navigate = (e: React.MouseEvent | React.KeyboardEvent, url: string) => {
    e.preventDefault()
    history.push(url)
  }

  if (!selected) {
    return <></>
  }

  return (
    <Paper square className={classes.root}>
      <NavigationTabs value={selected} onChange={handleChange}>
        {navItems.map((x) => (
          <NavigationTab label={x.label} onClick={navigate} value={x.path} key={x.path} />
        ))}
      </NavigationTabs>
      {currentUser?.isGlobalAdmin && <SearchUser />}
    </Paper>
  )
}

export default NavigationBar
